import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { parseDateMMDDYYYYSlashes, dateToMMDDYY } from '../dates';
import { MED_IS_CURRENT_VERSION_FALSE, MED_IS_CURRENT_VERSION_TRUE, STRING_FALSE, STRING_TRUE } from '../constants';
import defaults from '../translationDefaults/en';

const isMarkedCurrent = med => med.iscurrentversion === MED_IS_CURRENT_VERSION_TRUE;

const isBefore = (a, b) => new Date(a) < (typeof b === 'string' ? parseDateMMDDYYYYSlashes(b) : new Date(b));

export const isActiveMed = (med, today) => // med objects in idg dto's do not have an iscurrentversion field and may have null stopdate's
(!med.iscurrentversion || isMarkedCurrent(med)) && (!med.stopdate_shifted || isBefore(today, med.stopdate_shifted)); // returns only the current version in each med series that has an active med

export const getActiveMedications = (meds, today) => Array.isArray(meds) && meds.length ? meds.filter(med => isActiveMed(med, today)) : [];
export const makeActiveIdHash = (meds, today) => {
  const idHash = {};
  meds.forEach(m => {
    if (isActiveMed(m, today || new Date())) {
      idHash[m.externalid] = m;
    }
  });
  return idHash;
}; // returns all meds in each active series
// for every medication, checks if idHash[el.externalid] is defined
// if so, this med should be rendered in the active meds section

export const getActiveSeriesMeds = (allMedications, activeHash) => allMedications.filter(el => !!activeHash[el.externalid]); // returns meds not in an active series

export const getFullyDiscontinuedMeds = (allMedications, activeHash) => allMedications.filter(el => !activeHash[el.externalid]); // if meds are in the same series, sort by stop date
// else compare alphanumerically

export const sortMeds = (a, b) => {
  if (a.externalid === b.externalid) {
    return Number(b.medseriesrank) - Number(a.medseriesrank);
  }

  return a.drugdescription.localeCompare(b.drugdescription);
};
export const getStoppedMedications = (meds, today) => Array.isArray(meds) && meds.length ? meds.filter(med => {
  const isStopped = med.iscurrentversion === MED_IS_CURRENT_VERSION_FALSE || med.stopdate_shifted && today > parseDateMMDDYYYYSlashes(med.stopdate_shifted);
  return isStopped;
}).map(med => _objectSpread(_objectSpread({}, med), {}, {
  stopped: true
})) : [];
export const orderingPhysicianLabel = med => {
  const {
    orderingphysicianfirstname: firstName,
    orderingphysicianlastname: lastName,
    orderingphysiciancredentials: credentials
  } = med;
  return `${lastName}, ${firstName}${credentials ? `, ${credentials}` : ''}`;
};
export const verbalReceived = med => {
  const {
    preparerfirstname: firstName,
    preparerlastname: lastName
  } = med;
  return firstName ? `${lastName}, ${firstName}` : '';
};
export const getCoveredLabel = covered => {
  if (covered === STRING_TRUE) {
    return defaults.common.coveredYes;
  } else if (covered === STRING_FALSE) {
    return defaults.common.coveredNo;
  }

  return '';
};
export const getAllMedications = meds => Array.isArray(meds) && meds.length ? meds : [];
export const formatDate = m => m ? dateToMMDDYY(m) : '';